import { render, staticRenderFns } from "./ConfigsActions.vue?vue&type=template&id=18657b5a&"
import script from "./ConfigsActions.vue?vue&type=script&lang=js&"
export * from "./ConfigsActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports